export const TEAM_NAME = 'teamName';

export const LDAP_GROUP_NAME = 'authorizerId';
